<template>
  <div class="c-library-upload">
    <upload-filter
      ref="filterRef"
      slot="filter"
      :operator-data="operatorData"
      :account-data="accountData"
      :state-data="stateData"
      @on-change="filterData"
    />
    <Viewport v-model="height">
      <el-table
        ref="libraryUploadTable"
        class="common-el-table-styles"
        v-loading="loading"
        :data="tableData"
        :height="height"
        border
        style="width: 100%"
      >
        <el-table-column
          v-for="(col, id) in tableColumns"
          :key="id + col.key"
          :prop="col.key"
          :label="col.title"
          :fixed="col.fixed"
          :show-overflow-tooltip="col.overflow"
          :min-width="col.width"
          :align="col.align"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="col.key === 'control' && scope.row.taskStatus !== 2"
              :loading="scope.row.retring"
              @click="retryTask(scope.row)"
              >重试
            </el-button>
            <a-image
              v-else-if="col.key === 'content'"
              :src="scope.row.cover"
              :width="100"
              :video="scope.row.video"
              :row="scope.row"
              hide-video
              :double="scope.row['double']"
              :multiple="scope.row['multiple']"
              @on-click="showMedia"
            />
            <span v-else-if="col.key === 'taskStatus'">
              {{ toTaskStatus(scope.row[col.key], scope.row) }}
            </span>
            <span v-else-if="col.key === 'materialType'">{{ toMaterType(scope.row[col.key]) }}</span>
            <span v-else-if="col.key === 'upType'">{{ toUpType(scope.row[col.key]) }}</span>
            <span v-else-if="col.key === 'createTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
            <span v-else-if="col.key === 'updateTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
            <span v-else>{{ scope.row[col.key] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="pager" style="text-align: right">
        <el-pagination
          :current-page.sync="pageIndex"
          :page-size.sync="pageSize"
          :total="total"
          :page-sizes="[10, 30, 50, 100]"
          @current-change="changePageIndex"
          @size-change="changePageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
        >
        </el-pagination>
      </div>
    </Viewport>
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue'
import UploadFilter from './components/upload-filter.vue'
import { useUploadTable, useUploadDictionaries, useUploadOperations, useUploadFormatters } from './hooks/useUpload'

const { proxy } = getCurrentInstance()

// Refs
const filterRef = ref(null)
const libraryUploadTable = ref(null)

// Hooks
const { loading, pageIndex, pageSize, total, tableData, tableColumns, height, getData, changePageIndex, changePageSize, filterData } =
  useUploadTable(proxy)

const { operatorData, accountData, stateData, preloadData } = useUploadDictionaries()

const { retryTask, showMedia } = useUploadOperations(proxy, getData)

const { toTaskStatus, toMaterType, toUpType } = useUploadFormatters(stateData)

// Lifecycle
onMounted(preloadData)
</script>

<style lang="scss" scoped></style>
